import { render, staticRenderFns } from "./PronosticoMeteorologicoFooter.vue?vue&type=template&id=58cbb2fa&scoped=true"
import script from "./PronosticoMeteorologicoFooter.vue?vue&type=script&lang=ts"
export * from "./PronosticoMeteorologicoFooter.vue?vue&type=script&lang=ts"
import style0 from "./PronosticoMeteorologicoFooter.vue?vue&type=style&index=0&id=58cbb2fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbb2fa",
  null
  
)

export default component.exports